import http from "./httpService";
import config from "config.json";
const { apiUrl } = config;

const getCreditTransactionHisory = async (query) => {
  const data = await http.get(
    `${apiUrl}/members/transaction-history${query ? `?${query}` : ""}`
  );
  return data;
};

const getrequisition = async (query) => {
  const data = await http.get(
    `${apiUrl}/apiuserrequisition/all${query ? `?${query}` : ""}`
  );
  return data;
};

const exportRequisition = async (queryString) => {
  try {
    const url = `${apiUrl}/apiuserrequisition/allrequisition/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const getAllCreditReports = async (query) => {
  const data = await http.get(
    `${apiUrl}/requisition/search-all-credit-requisition${
      query ? `?${query}` : ""
    }`
  );
  return data;
};

const getrequisitionForEdit = async (ReqId) => {
  const { data } = await http.get(
    `${apiUrl}/apiuserrequisition/apiuserrequsition/${ReqId}`
  );
  return data;
};

const approveReq = async (value) => {
  try {
    const url = `${apiUrl}/apiuserrequisition/approve-apiuserrequisition`;
    const { data } = await http.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};
const approveReqByDistributor = async (value) => {
  try {
    const url = `${apiUrl}/requisition/approve-by-distributor`;
    const { data } = await http.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const declineReq = async (value) => {
  try {
    const url = `${apiUrl}/apiuserrequisition/decline-apiuserrequisition`;
    const { data } = await http.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};
const getRequisitionBankList = async () => {
  try {
    const { data } = await http.get(
      `${apiUrl}/masterbanks/master-requisition-banks`
    );
    // console.log(data);
    return data;
  } catch (error) {
    // console.log(error);
  }
};
const declineReqByDistributor = async (value) => {
  try {
    const url = `${apiUrl}/requisition/decline-by-distributor`;
    const { data } = await http.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const addRedHandler = async (value) => {
  try {
    const url = `${apiUrl}/apiuserrequisition`;
    const { data } = await http.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};
const addReqToAdmin = async (value) => {
  try {
    const url = `${apiUrl}/requisition/admin-send-requisition`;
    const { data } = await http.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const creditSettlement = async (value) => {
  // try {
  const url = `${apiUrl}/requisition/credit-balance-settlement`;
  const { data } = await http.post(url, value);
  return data;
  // } catch (error) {
  //   throw error;
  // }
};

const updateReq = async (value) => {
  try {
    const url = `${apiUrl}/apiuserrequisition/masteradmin-requisition-update`;
    const { data } = await http.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const reactiveReq = async (value) => {
  try {
    const url = `${apiUrl}/requisition/activate-decline-requisition`;
    const { data } = await http.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const exportCreditReports = async (query) => {
  try {
    const url = `${apiUrl}/members/merchants-credit-limit/export${
      query ? `?${query}` : ""
    }`;
    const data = await http.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const creditLimit = async (query) => {
  const data = await http.get(
    `${apiUrl}/members/merchants-credit-limit${query ? `?${query}` : ""}`
  );
  return data;
};

export {
  getCreditTransactionHisory,
  getrequisition,
  exportRequisition,
  getAllCreditReports,
  getrequisitionForEdit,
  approveReq,
  approveReqByDistributor,
  declineReq,
  getRequisitionBankList,
  declineReqByDistributor,
  addRedHandler,
  addReqToAdmin,
  creditSettlement,
  updateReq,
  reactiveReq,
  exportCreditReports,
  creditLimit,
};
